import _extends from "@babel/runtime/helpers/extends";

/**
 * Wraps all provided actions in a new function that dispatches them.
 *
 * Functionally equivalent to the `mapDispatchToProps` option in the `connect` function.
 *
 * This is primarily used for creating hooks that provide a redux model's actions to a component.
 *
 * ```js
 * import { mapDispatchToActions } from '@minerva-analytics/pantheon';
 * const store = createStore(); // some redux store
 *
 * const actions = {
 *   action1: () => ({ type: 'SOME_ACTION_1' }),
 *   action2: () => ({ type: 'SOME_ACTION_2' }),
 * }
 *
 * const mappedActions = mapDispatchToActions(dispatch, actions);
 *
 * // equivalent to `dispatch(actions.action1());`
 * mappedActions.action1();
 * ```
 *
 * @param {Function} dispatch - The dispatch function for your redux store
 * @param {Object} actions - The actions to map dispatch to
 *
 * @returns {Object} - The mapped actions
 */
var mapDispatchToActions = function mapDispatchToActions(dispatch, actions) {
  return Object.keys(actions).reduce(function (mappedActions, action) {
    var _extends2;

    return _extends({}, mappedActions, (_extends2 = {}, _extends2[action] = function () {
      return dispatch(actions[action].apply(actions, arguments));
    }, _extends2));
  }, {});
};

export default mapDispatchToActions;